import React, { useEffect, useState } from "react";
import {
    Box,
    Center,
    Text,
    Button,
    Link,
    Heading,
    Divider,
    useDisclosure,
    HStack,
    Flex,
} from "@chakra-ui/react";
import { GenerateCanva } from "components/generate-canva";
import toast from "react-hot-toast";
import PuffLoader from "react-spinners/PuffLoader";
import Tweets from "components/tweets";
import Tweet from "components/tweets/masonry/tweet";
import { useRouter } from "next/dist/client/router";
import * as analytics from "utils/analytics";
import { ConfirmPopup } from "components/popups/confirmPopup";

let isLocal = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

export const getBestTweets = async () => {
    let postOnTwitterLinkBefore = "A 🤖 wrote this for me: ";
    const response = await fetch("https://us-central1-ez4cast.cloudfunctions.net/tweetGeneration-getBestGenerations?t=" + Date.now());
    const json = await response.json();
    if (json?.success && json?.tweets?.length) {
        let bestTweets = json.tweets.map(x => {
            return {
                ...x,
                postOnTwitterLink: `https://twitter.com/intent/tweet?text=${encodeURIComponent(x.full_text + "\n\n" + postOnTwitterLinkBefore + " tweethunter.io/generate-tweets/" + x?.user?.screen_name + " 🤯")}`
            }
        });
        // setTweetsBest(bestTweets);
        return bestTweets;
    }
    return [];
}

export const GenerateTweets = ({
    twUserName = "",
    title,
    subtitle,
    desc,
    url,
    image,
    bestTweets,
    noIndex = false,
}) => {

    const [tweets, setTweets] = useState([]);
    // const [tweetsBest, setTweetsBest] = useState([]);
    const [account, setAccount] = useState<any>({});
    const [isSending, setIsSending] = React.useState(false);
    const [refresh, refresher] = React.useState({});
    const router = useRouter();
    const { isOpen: isOpenLimit, onOpen: onOpenLimit, onClose: onCloseLimit } = useDisclosure();
    const [isCollapse, setIsCollapse] = React.useState(true);

    let postOnTwitterLinkBefore = "A 🤖 wrote this for me: ";

    const onClickSuggestion = async () => {

    }

    const voteAction = async (tweet, vote) => {
        toast.success("thanks for your vote");
        // analytics.log("public_generate_tweets_vote", {vote, twUserName: tweet?.user?.screen_name, idTweet: tweet?.id});
        // console.log('sending vote: ' + vote, tweet);
        const response = await fetch("https://us-central1-ez4cast.cloudfunctions.net/tweetGeneration-vote?idTweet=" + tweet.id + "&vote=" + vote);
        const json = await response.json();
    }

    const sendRequest = async (session, value) => {

        // console.log('sendRequest value:', value);
        // return;

        if (!value)
            return;

        setIsSending(true);

        // analytics.log("public_generate_tweets", {twUserName: value});

        // console.log("sendRequest");
        const response = await fetch("https://europe-west1-ez4cast.cloudfunctions.net/tweetGeneration-generateTweetsEurope?twUserName=" + value + "&t=" + Date.now());
        const json = await response.json();

        if (json?.success && json?.tweets?.length) {
            let generatedTweets = json.tweets.map(x => {
                return {
                    ...x,
                    user: {
                        ...json.account,
                    },
                    postOnTwitterLink: `https://twitter.com/intent/tweet?text=${encodeURIComponent(x.full_text + "\n\n" + postOnTwitterLinkBefore + " tweethunter.io/generate-tweets/" + x?.user?.screen_name + " 🤯")}`
                }
            });
            // console.log('generatedTweets:', generatedTweets)
            setTweets(generatedTweets);
            setAccount(json.account);
        }
        else {
            console.log('generation error: ' + json?.error);

            if (json?.error?.includes("too much")) {
                onOpenLimit();
            }
            else {
                console.log('toast');
                toast.error(json?.error ?? "Tweet generation failed");
            }
        }
        setIsSending(false);
    }

    useEffect(() => {
        // getDefaults();
        if (twUserName) {
            sendRequest(undefined, twUserName);
        }
        // getBestTweets();
        // setSuggestions(shuffleArray(suggestionsStatic));
        analytics.log("public_generate_tweets_visit", { twUserName: twUserName ?? "" });
    }, []);

    return (
        <Box>

            <GenerateCanva
                title={title}
                subtitle={subtitle}
                desc={desc}
                url={url}
                image={image}
                suggestions={suggestionsStatic}
                placeholder="@patxol"
                sendRequest={sendRequest}
                onClickSuggestion={onClickSuggestion}
                defaultValue={twUserName}
                isLoading={isSending}
                noIndex={noIndex}
            >
                <Center minH="600px" w="100%" p={4} flexDir="column">
                    {
                        isSending && (
                            <Center py={10}>
                                <PuffLoader color={"hsl(203, 100%, 36%)"} loading={isSending} css="display: block; margin: 0 auto; border-color: red;" size={50} />
                            </Center>
                        )
                    }
                    {
                        //@ts-ignore
                        !isSending && tweets?.length > 0 && (
                            <Box>
                                <Heading textAlign="center" as="h2" fontSize={"2xl"}>Tweets <Link href={"https://twitter.com/" + account.screen_name} isExternal >{account?.name}</Link> could have published</Heading>
                                <Box mt={5}>
                                    <Tweets
                                        savedTweet={[]}
                                        tweets={tweets}
                                        disableBlur={true}
                                        disableBookmarkButton={true}
                                        refresher={refresher}
                                        refresh={refresh}
                                        disableSaveCsv={true}
                                        disableEmbed={true}
                                        disableEditTweet={true}
                                        disableTryAgain={true}
                                        source="ez4cast"
                                        isVariation={true}
                                        disableSubMenu={true}
                                        disableName={false}
                                        disableVotes={false}
                                        voteAction={voteAction}
                                        masonryProps={{ overscanBy: 999 }}
                                        overrideRootUrl={"/generate-tweets/"}
                                        disablePostOnTwitter={false}
                                        disableRefreshProfilePic={true}
                                        addSubscribeTile={true}
                                        utmSource="generate-tweets"
                                    />
                                </Box>
                                <Center>
                                    <Box mt={10} maxW="800px">
                                        <Text textAlign="center" >We use the last AI to generate tweets with the same writing style as famous Twitter content creators while matching what they talk about. The same AI powers <Link href="https://tweethunter.io/?utm_source=generate-tweets" target="_blank" >Tweet Hunter</Link> which helps thousands creators build a Twitter audience to grow their business faster.</Text>
                                    </Box>
                                </Center>
                            </Box>
                        )
                    }
                    {
                        !isSending && tweets?.length == 0 && (
                            <Center mb={20}>
                                <Heading fontSize="lg" as="i">Input any Twitter account and watch the AI write like them</Heading>
                            </Center>
                        )
                    }
                    {
                        bestTweets?.length > 6 && (
                            // <Box mt={10}>
                            //     <Center>
                            //         <Divider maxW="200px" />
                            //     </Center>
                            //     <Heading mt={10} textAlign="center" as="h2" fontSize={"2xl"}>Last Generated Tweets by the community</Heading>
                            //     <Box mt={5}>
                            //         <Tweets
                            //             savedTweet={[]}
                            //             tweets={bestTweets}
                            //             disableBlur={true}
                            //             disableBookmarkButton={true}
                            //             refresher={refresher}
                            //             refresh={refresh}
                            //             disableSaveCsv={true}
                            //             disableEmbed={true}
                            //             disableEditTweet={true}
                            //             disableTryAgain={true}
                            //             source="ez4cast"
                            //             isVariation={true}
                            //             disableSubMenu={true}
                            //             disableName={false}
                            //             disableVotes={false}
                            //             voteAction={voteAction}
                            //             masonryProps={{overscanBy: 999}}
                            //             overrideRootUrl={"/generate-tweets/"}
                            //             disablePostOnTwitter={false}
                            //             disableRefreshProfilePic={true}
                            //         />
                            //     </Box>
                            // </Box>
                            <Box mt={5} maxW="1000px" w="100%">
                                <Center>
                                    <Divider maxW="200px" />
                                </Center>
                                <Heading mt={10} textAlign="center" as="h2" fontSize={"2xl"}>Last Generated Tweets by the community</Heading>
                                <Center mt={10}>
                                    {
                                        isCollapse ? (
                                            <HStack
                                                flexDir={{ base: "column", lg: "row" }}
                                                spacing={{ base: 0, lg: 3 }}
                                                alignItems="flex-start"
                                                mt={2}
                                                maxW="1000px"
                                                w="100%"
                                            >
                                                {
                                                    bestTweets?.slice(0, 3)?.map((tweet, index) => (
                                                        <Box key={index + "-" + tweet.id} w={{ base: "100%", lg: "400px" }} pt={{ base: "2", lg: "0" }} >
                                                            <Tweet
                                                                key={"collapse-tweets-" + index}
                                                                savedTweet={[]}
                                                                tweet={{ data: tweet }}
                                                                disableBookmarkButton={true}
                                                                disableRequest={true}
                                                                disableHideButton={true}
                                                                disableEditTweet={true}
                                                                forceDisplayName={true}
                                                                source="ez4cast"
                                                                isVariation={true}
                                                                disableSubMenu={true}
                                                                disableName={false}
                                                                disableVotes={false}
                                                                voteAction={voteAction}
                                                                overrideRootUrl={"/generate-tweets/"}
                                                                disablePostOnTwitter={false}
                                                                disableRefreshProfilePic={true}
                                                            />
                                                        </Box>
                                                    ))
                                                }
                                            </HStack>
                                        ) : (
                                            <Tweets
                                                savedTweet={[]}
                                                tweets={bestTweets}
                                                disableBlur={true}
                                                disableBookmarkButton={true}
                                                refresher={refresher}
                                                refresh={refresh}
                                                disableSaveCsv={true}
                                                disableEmbed={true}
                                                disableEditTweet={true}
                                                disableTryAgain={true}
                                                source="ez4cast"
                                                isVariation={true}
                                                disableSubMenu={true}
                                                disableName={false}
                                                disableVotes={false}
                                                voteAction={voteAction}
                                                masonryProps={{ overscanBy: 999 }}
                                                overrideRootUrl={"/generate-tweets/"}
                                                disablePostOnTwitter={false}
                                                disableRefreshProfilePic={true}
                                            />
                                        )
                                    }
                                </Center>
                                <Flex mt={5} mb={5} w="100%" justifyContent="flex-end">
                                    <Button variant="tertiaryNoBackground" onClick={(e) => { setIsCollapse(!isCollapse); refresher({}); }}>
                                        {isCollapse ? "See more..." : "Collapse"}
                                    </Button>
                                </Flex>
                            </Box>
                        )
                    }
                    <Center flexDir={"column"} mb={10}>
                        <Divider maxW="200px" mt={10} />
                        <Heading mt={10} fontSize="2xl">Want to drive more opportunities from Twitter?</Heading>
                        <Text mt={2} fontSize="md">Content Inspiration, AI, scheduling, automation, analytics, CRM.</Text>
                        <Text mt={2} fontSize="md">Get all of that and more in Tweet Hunter.</Text>
                        <Button
                            mt={5}
                            borderRadius={"xl"}
                            bg={"gray.800"}
                            color={"white"}
                            as="a"
                            target="_blank"
                            href="https://tweethunter.io/?utm_source=generate-tweets&utm_medium=free-tool"
                        >
                            <Text mr={3}>Try Tweet Hunter for free</Text>
                        </Button>
                    </Center>
                </Center>
            </GenerateCanva>

            <ConfirmPopup
                isOpen={isOpenLimit}
                onClose={onCloseLimit}
                title="Oops, you’ve reached the limit!"
                allowClickBackground={true}
                body={"We’re getting a lot of traffic right now, so we limited the number of requests you can make! Come back tomorrow for some more, or become a Tweet Hunter user and unlock tons of features."}
                cta="Try Tweet Hunter"
                callback={async () => {
                    window.location.href = "https://tweethunter.io?utm_source=generate-tweets&utm_medium=free-tool";
                }}
            />
        </Box>
    );
};

const suggestionsStatic = [
    {
        "key": "naval",
        "label": "Naval"
    },
    {
        "key": "dickiebush",
        "label": "Dickie Bush 🚢"
    },
    {
        "key": "wes_kao",
        "label": "Wes Kao 🏛"
    },
    {
        "key": "sweatystartup",
        "label": "Nick Huber"
    },
    {
        "key": "TrungTPhan",
        "label": "Trung Phan"
    },
    {
        "key": "lennysan",
        "label": "Lenny Rachitsky"
    },
    {
        "key": "patxol",
        "label": "Patxol"
    },
    {
        "key": "balajis",
        "label": "Balaji Srinivasan"
    },
    {
        "key": "jackbutcher",
        "label": "Jack Butcher"
    },
    {
        "key": "patio11",
        "label": "Patrick McKenzie"
    },
    {
        "key": "paulg",
        "label": "Paul Graham"
    },
    {
        "key": "levelsio",
        "label": "levelsio"
    },
    {
        "key": "thesamparr",
        "label": "Sam Parr 👀"
    },
    {
        "key": "APompliano",
        "label": "Pomp 🌪"
    },
    {
        "key": "ShaanVP",
        "label": "Shaan Puri"
    },
    {
        "key": "Julian",
        "label": "Julian Shapiro"
    },
    {
        "key": "andrewchen",
        "label": "Andrew Chen 🎮"
    },
    {
        "key": "SahilBloom",
        "label": "Sahil Bloom"
    },
];
